import React from "react";
import materialUI from "../../images/method-draw-image.svg";
import firebase from "../../images/firebase.svg";
import redux from "../../images/redux.svg";
import "./Skills.css";

const Skills = () => {
  return (
    <section id='skills' className='pt-5'>
      <h1 className='text-center mt-3'>Skills</h1>
      <div
        style={{
          background: "#030C1A",
          borderTop: "3px solid #7b9095",
          borderBottom: "3px solid #7b9095",
          paddingTop: "30px",
        }}
      >
        <p className='text-center text-white'>
          There is some skills that I work with & I always look to get new
          technologies to learn.
        </p>

        <div className='row row-cols-2 row-cols-md-3 pt-2 text-white alignment align-items-center'>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className='d-flex align-items-center'>
              <i className='devicon-react-original display-4'></i>
            </div>
            <h5>React.js</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i className='devicon-nodejs-plain display-4'></i>
            </div>
            <h5>Node.js</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i class='devicon-express-original display-4'></i>
            </div>
            <h5>Express.js</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i className='devicon-javascript-plain display-4'></i>
            </div>
            <h5>JavaScript</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <img width='60px' style={{ color: "#fff" }} src={redux} alt='' />
            </div>
            <h5>Redux</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i
                style={{ fontSize: "50px" }}
                className='devicon-sass-original'
              ></i>
            </div>
            <h5>SASS & SCSS</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i className='devicon-html5-plain display-4'></i>
            </div>
            <h5>HTML</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i className='devicon-css3-plain display-4'></i>
            </div>
            <h5>CSS</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i class='devicon-bootstrap-plain display-4'></i>
            </div>
            <h5>Bootstrap</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <img
                width='60px'
                style={{ color: "#fff" }}
                src={materialUI}
                alt=''
              />
            </div>
            <h5>Material UI</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i class='devicon-mongodb-plain display-4'></i>
            </div>
            <h5>Mongodb</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'></div>
            <h5>Mongoose</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <img
                width='60px'
                style={{ color: "#fff" }}
                src={firebase}
                alt=''
              />
            </div>
            <h5>Firebase</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i class='devicon-heroku-original display-4'></i>
            </div>
            <h5>Heroku</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i style={{ fontSize: "50px" }} class='devicon-github-plain'></i>
            </div>
            <h5>GitHub</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i class='devicon-npm-original-wordmark display-4'></i>
            </div>
            <h5>npm</h5>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center icon-transition pb-3'>
            <div className=' d-flex align-items-center'>
              <i class='devicon-visualstudio-plain display-4'></i>
            </div>
            <h5>Visual Studio</h5>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
